export enum LUMX_CHAT {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=608751164
     */
    SEND_A_MESSAGE = 'LUMX_CHAT.SEND_A_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=608966441
     */
    MESSAGE_SENT = 'LUMX_CHAT.MESSAGE_SENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=609029158
     */
    MESSAGE_RECEIVED = 'LUMX_CHAT.MESSAGE_RECEIVED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612608119
     */
    INCOMING_MESSAGE = 'LUMX_CHAT.INCOMING_MESSAGE',
}
